module.exports = __webpack_public_path__ + "assets/img/btnVideo.4cd89255.svg";